import { useEffect, useState } from 'react';
import { Switch, Select } from 'antd';
import { useAppDispatch, useAppSelector } from '@hooks/redux';
import {
  pickedInterbankTemplateAC,
  pickedInternalTemplateAC,
  pickedSwiftRubTemplateAC,
  pickedSwiftTemplateAC,
} from '@store/reducers/user';
import { useTranslation } from 'react-i18next';
import { getAllCounterpartiesApi } from '@http/counterparties';

function SelectCounterparty(props: any) {
  const { type } = props;

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const counterparties: any = useAppSelector(state => state.counterpartiesReducer.counterparties);
  const permissions = useAppSelector(state => state.userReducer.permissions);

  const [showTemplate, setShowTemplate] = useState(false);

  const pickedTemplate = (item: any) => {
    if (type === 'INTERBANK') {
      dispatch(pickedInterbankTemplateAC(item));
    }
    if (type === 'INTERNAL') {
      dispatch(pickedInternalTemplateAC(item));
    }
    if (type === 'SWIFT') {
      dispatch(pickedSwiftTemplateAC(item));
    }
    if (type === 'SWIFT_RUB') {
      dispatch(pickedSwiftRubTemplateAC(item));
    }
  };

  useEffect(() => {
    if (permissions?.cpty[0].allow_view) {
      dispatch(
        getAllCounterpartiesApi(
          1,
          {
            counterparty_type: type === 'INTERBANK' || type === 'INTERNAL' ? 'RESIDENT' : 'FOREIGN',
            is_request: '0',
          },
          300
        )
      );
    }
  }, []);

  return (
    <div>
      <div className='flex'>
        <p className='text-bs mr-4 color-active'>{t('Pick counterparty')}</p>
        <Switch onChange={value => setShowTemplate(value)} />
      </div>
      {showTemplate ? (
        <div className='mt-5'>
          <p className='text-bs color-title mb-1 md:hidden'>{t('Select counterparty')}:</p>
          <div className='md:grid grid-cols-7 md:mt-7'>
            <p className='col-span-2 text-bs color-title max-md:hidden'>{t('Select counterparty')}:</p>
            <div className='col-span-5'>
              <Select
                size='large'
                style={{ width: '100%' }}
                options={counterparties}
                onChange={(_, item: any) => pickedTemplate(item)}
                filterOption={(input, option) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                showSearch
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default SelectCounterparty;
